import {
  type CritType,
  type CriterionOptinDate,
  type CriterionOptoutType,
  type CriterionUndefined,
  type Identifier,
  critTypeDefaultMap,
} from 'Pages/RecipientsList/model'
import { searchFiltersState } from 'Pages/RecipientsList/recoil/state/filters'

import type { CallbackInterface } from 'recoil'

import type { SubscriptionStatus } from 'Types/beRecipientsApi'

export const filtersChangeCallback =
  ({ set }: CallbackInterface) =>
  async (fieldName: string, fieldValue: string | SubscriptionStatus[]) => {
    set(searchFiltersState, (prev) => ({
      ...prev,
      [fieldName]: {
        value: fieldValue,
        dirty: true,
      },
    }))
  }

export const addCriterionCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    const newCriterion: CriterionUndefined = { critType: 'undefined' }

    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: [...criteria.value, newCriterion],
        dirty: true,
      },
    }))
  }

export const removeCriterionCallback =
  ({ set }: CallbackInterface) =>
  async (index: number) => {
    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: [...criteria.value.filter((_, idx) => idx !== index)],
        dirty: true,
      },
    }))
  }

export const changeCriterionTypeCallback =
  ({ set }: CallbackInterface) =>
  async (critType: CritType, index: number) => {
    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: criteria.value.map((item, idx) =>
          idx === index
            ? critType === item.critType
              ? item
              : { ...critTypeDefaultMap[critType] }
            : item,
        ),
        dirty: true,
      },
    }))
  }

export const changeIdentifierCallback =
  ({ set }: CallbackInterface) =>
  async (identifier: Identifier, index: number) => {
    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: criteria.value.map((item, idx) =>
          idx === index
            ? {
                ...item,
                identifier,
              }
            : item,
        ),
        dirty: true,
      },
    }))
  }

export const changeCriterionCallback =
  ({ set }: CallbackInterface) =>
  async (p: string, v: any, index: number) => {
    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: criteria.value.map((item, idx) =>
          idx === index
            ? {
                ...item,
                [p]: v,
              }
            : item,
        ),
        dirty: true,
      },
    }))
  }

export const changeDatesTypeCallback =
  ({ set }: CallbackInterface) =>
  async (
    v: 'beforeDate' | 'afterDate' | 'interval' | undefined,
    index: number,
  ) => {
    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: criteria.value.map((item: CriterionOptinDate, idx) =>
          idx === index
            ? {
                ...item,
                datesType: v,
                dateFrom: v === 'beforeDate' ? undefined : item.dateFrom,
                dateTo: v === 'afterDate' ? undefined : item.dateTo,
              }
            : item,
        ),
        dirty: true,
      },
    }))
  }

export const changeOptoutChannelCallback =
  ({ set }: CallbackInterface) =>
  async (v: 'email' | 'sms', index: number) => {
    set(searchFiltersState, ({ criteria, ...prev }) => ({
      ...prev,
      criteria: {
        ...criteria,
        value: criteria.value.map((item: CriterionOptoutType, idx) =>
          idx === index
            ? {
                ...item,
                channel: v,
                optoutType: v === item.channel ? item.optoutType : undefined,
              }
            : item,
        ),
        dirty: true,
      },
    }))
  }
